// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_8g-0";
export var headerCellHover = "_8g-1";
export var readCellContainer = "_8g-2";
export var readCellSlot = "_8g-3";
export var rowHoverCheckbox = "_8g-4";
export var rowUnreadIndicator = "_8g-5";
export var searchHighlight = "_8g-8";
export var supportTicketRow = "_8g-6";
export var unreadIndicator = "_8g-7";